import { formatScore } from 'react-common'
import { useTranslation } from 'react-i18next'
import parseISO from 'date-fns/parseISO'
import { GradeRevealPolicy, LearnerObjectiveAccessCompactModel, ObjectiveWorkflowState } from '@/api/models/aggregate'

export const useGradingVisibility = (aggregate: LearnerObjectiveAccessCompactModel | null | undefined) => {
  const { t } = useTranslation()

  const { lastObjectiveWorkflow, lastObjectiveRecord } = aggregate?.objectiveWorkflowAggregate || {}
  const { gradeRevealPolicy, gradeRevealDate: rawGradeRevealDate } = aggregate || {}
  const { state: workflowState } = lastObjectiveWorkflow || {}

  const gradeRevealDate = rawGradeRevealDate ? parseISO(rawGradeRevealDate) : null
  const isBeforeFromGradeRevealDate = gradeRevealDate ? gradeRevealDate > new Date() : false

  const isGradeRevealNeverShow = gradeRevealPolicy === GradeRevealPolicy.Never
  const isAfterFinishSelected = gradeRevealPolicy === GradeRevealPolicy.AfterFinish
  const isAfterDateSelected = gradeRevealPolicy === GradeRevealPolicy.AfterDate

  const isSubmittedOrGrading = [
    ObjectiveWorkflowState.submitted,
    ObjectiveWorkflowState.inGrading,
    ObjectiveWorkflowState.graded,
    ObjectiveWorkflowState.gradingApproved,
  ].includes(workflowState!)

  const hasWorkflow = Boolean(lastObjectiveWorkflow)
  const isNotInProgress = workflowState !== ObjectiveWorkflowState.inProgress
  const isInGrading = workflowState === ObjectiveWorkflowState.inGrading

  const isFinished = hasWorkflow
    ? workflowState === ObjectiveWorkflowState.finished
    : Boolean(lastObjectiveRecord?.finished)

  const isCompletedBeforeGradeReveal =
    isAfterDateSelected && isBeforeFromGradeRevealDate && isNotInProgress && hasWorkflow

  const showGrade = (() => {
    if (isGradeRevealNeverShow) return false
    if (isAfterFinishSelected && isSubmittedOrGrading) return true
    if (isCompletedBeforeGradeReveal) return false
    if (isInGrading) return true
    if (isFinished) return true
    return false
  })()

  const gradeDotColor = 'var(--color-danger)'
  const gradingLabel = t('courseDetails.gradingInProgress')

  const finishedScore =
    isFinished && lastObjectiveRecord
      ? formatScore({ score: lastObjectiveRecord.score, maxScore: lastObjectiveRecord.maxScore })!
      : ''

  return {
    showGrade,
    isSubmittedOrGrading,
    isCompletedBeforeGradeReveal,
    gradeDotColor,
    gradingLabel,
    finishedScore,
  }
}
